/** @jsx h */
import { h } from 'preact'

const LocalisationIcon = ({
  style = {},
  fill = '#757575',
  stroke = '#757575',
  width = '16.99',
  height = '16.99',
  className = '',
  viewBox = '0 0 16.99 16.99'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`rcc_c_localisation-icon ${className}`}
    aria-hidden='true'
  >
    <g transform='translate(1.888 1.888)' fill='none' stroke={stroke} strokeMiterlimit='10' strokeWidth='1'>
      <circle cx='6.607' cy='6.607' r='6.607' stroke='none' />
      <circle cx='6.607' cy='6.607' r='6.107' fill='none' />
    </g>
    <circle cx='1.982' cy='1.982' r='1.982' transform='translate(6.513 6.513)' fill={fill} />
    <line y1='1.982' transform='translate(8.495)' fill='none' stroke={stroke} strokeMiterlimit='10' strokeWidth='1' />
    <path d='M2.5,0H0' transform='translate(0 8.495)' fill='none' stroke={stroke} strokeWidth='1' />
    <path d='M0-.52V2.055' transform='translate(8.495 14.934)' fill='none' stroke={stroke} strokeWidth='1' />
    <path d='M-.483,0H2.043' transform='translate(14.946 8.495)' fill='none' stroke={stroke} strokeWidth='1' />
  </svg>
)

export default LocalisationIcon
